module.exports = __webpack_public_path__ + "static/media/mem4.d3dd311a.webp";